import { createEvent, sample } from 'effector'
import { model as i18n } from '~/core/i18n'
import { model as announcements } from '~/entities/announcements'
import { model as subscriber } from '~/entities/subscriber'
import { installAnnouncementsModel } from '~/features/announcements'
import * as cslFeature from '~/features/concurrent-stream-limit'
import { model as favoritesFeature } from '~/features/favorites'
import { model as logoFeature } from '~/features/logo'
import { multiorgModel } from '~/features/multiorganization'
import { installNotificationsModel } from '~/features/notifications/install'
import { featuresNpawModel } from '~/features/npaw'
import * as pinLockFeature from '~/features/pin-lock'
import { model as pingerFeature } from '~/features/pinger'
import { playbackUrlAdParamsFeatureModel } from '~/features/playback-url-ad-params'
import { siginInToWatchFeatureModel } from '~/features/signin-to-watch'
import * as smartRestartFeature from '~/features/smart-restart'
import { subscriberFeatureModel } from '~/features/subscriber'
import { model as clock } from '~/shared/clock'
import { model as mq } from '~/shared/mq'
import { model as telemetry } from '~/shared/opentelemetry'
import { model as sentry } from '~/shared/sentri'
import { languagePickerModel } from '~/shared/ui/components/language-picker'
import { model as playerWidgetModel } from '~/widgets/Player'

export const init = createEvent()

//
// application launch
//

// init entities
sample({
  clock: init,
  target: [subscriber.init, announcements.init],
})

// init features
sample({
  clock: init,
  target: [
    multiorgModel.init,
    pingerFeature.init,
    favoritesFeature.init,
    logoFeature.init,
    installNotificationsModel.init,
    playbackUrlAdParamsFeatureModel.init,
    subscriberFeatureModel.init,
    installAnnouncementsModel.init,
    siginInToWatchFeatureModel.init,
    featuresNpawModel.init,
    pinLockFeature.init,
    cslFeature.init,
    smartRestartFeature.init,
  ],
})

// init widgets
sample({
  clock: init,
  target: [playerWidgetModel.init],
})

// setup application message queue, clock, and content-localization storage listener
sample({
  clock: init,
  target: [mq.setup, clock.setup, i18n.setupContentLocalization],
})

// init sentry
sample({
  clock: init,
  target: sentry.init,
})

// init telemetry
sample({
  clock: init,
  target: telemetry.init,
})

sample({
  clock: init,
  target: languagePickerModel.init,
})
